import React from 'react';
import styled from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const StyledInput = styled.input`
  width: 42.5px;
  height: 42.5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  outline: none;
  margin-top: 40px;
  margin-bottom: 25px;
  &:focus {
    border: 1px solid #eb1f3a;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const OptWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const SingleOtpInput = (_a) => {
  var _b = _a, { isFocus } = _b, rest = __objRest(_b, ["isFocus"]);
  const ref = React.useRef();
  React.useEffect(() => {
    if (isFocus && ref.current) {
      ref.current.focus();
    }
  }, [isFocus]);
  return /* @__PURE__ */ React.createElement(StyledInput, __spreadProps(__spreadValues({
    type: "number"
  }, rest), {
    ref
  }));
};
const OtpInput = ({
  onChange,
  className
}) => {
  const [otp, setOtp] = React.useState(["", "", "", "", "", ""]);
  const [currentFocus, setCurrentFocus] = React.useState(0);
  React.useEffect(() => {
    if (onChange)
      onChange(otp.join(""));
  }, [JSON.stringify(otp)]);
  return /* @__PURE__ */ React.createElement(OptWrapper, {
    className
  }, otp.map((item, index) => /* @__PURE__ */ React.createElement(SingleOtpInput, {
    key: index,
    value: otp[index],
    isFocus: currentFocus === index,
    onFocus: (e) => {
      setCurrentFocus(index);
      const temp = e.target.value;
      e.target.value = "";
      e.target.value = temp;
    },
    onChange: (e) => {
      const length = e.target.value.length;
      const value = e.target.value.slice(length - 1, length);
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index !== otp.length - 1)
        setCurrentFocus((prev) => prev + 1);
    },
    onKeyDown: (e) => {
      const handleDelete = (e2) => {
        e2.preventDefault();
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      };
      switch (e.keyCode) {
        case BACKSPACE:
          handleDelete(e);
          setCurrentFocus((prev) => prev !== 0 ? prev - 1 : prev);
          break;
        case DELETE:
          handleDelete(e);
          break;
        case LEFT_ARROW:
          setCurrentFocus((prev) => prev !== 0 ? prev - 1 : prev);
          break;
        case RIGHT_ARROW:
          setCurrentFocus((prev) => prev !== otp.length - 1 ? prev + 1 : prev);
          break;
      }
    }
  })));
};

export { OtpInput };
